import { Component, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RoutesRenderer from './routers/routerAuth';

export default class App extends Component {
    render() {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <BrowserRouter>
                    <RoutesRenderer />
                </BrowserRouter>
            </Suspense>
        );
    }
}
